import React, { useState } from 'react';
import * as api from '../services/api';
import './FeedbackWidget.css';

const FeedbackWidget = ({ isOpen, onClose }) => {
  const [rating, setRating] = useState(0);
  const [hoveredStar, setHoveredStar] = useState(0);
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a star rating');
      return;
    }
    try {
      setSubmitting(true);
      setError('');
      await api.submitFeedback({ rating, description: description.trim() || undefined });
      setSubmitted(true);
      setTimeout(() => handleClose(), 2000);
    } catch (err) {
      setError(err.message || 'Failed to submit feedback');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setRating(0);
    setHoveredStar(0);
    setDescription('');
    setSubmitting(false);
    setSubmitted(false);
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="feedback-overlay" onClick={handleClose}>
      <div className="feedback-widget" onClick={(e) => e.stopPropagation()}>
        <div className="feedback-header">
          <span className="feedback-title">Share Feedback</span>
          <button className="feedback-close" onClick={handleClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {submitted ? (
          <div className="feedback-success">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <p>Thank you for your feedback!</p>
          </div>
        ) : (
          <>
            <div className="feedback-stars-section">
              <p className="feedback-label">How is your experience?</p>
              <div className="feedback-star-row">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    className={`feedback-star ${star <= (hoveredStar || rating) ? 'active' : ''}`}
                    onMouseEnter={() => setHoveredStar(star)}
                    onMouseLeave={() => setHoveredStar(0)}
                    onClick={() => { setRating(star); setError(''); }}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill={star <= (hoveredStar || rating) ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </button>
                ))}
              </div>
            </div>

            <textarea
              className="feedback-textarea"
              placeholder="Tell us more (optional)..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={2000}
              rows={3}
            />

            {error && <p className="feedback-error">{error}</p>}

            <button
              className="feedback-submit-btn"
              onClick={handleSubmit}
              disabled={submitting || rating === 0}
            >
              {submitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackWidget;
